import React from 'react';

const EuiIconTableDensityNormal = props => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M16 3v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1zm-1 0V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v1h14zm0 1H1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4zM4.5 6a.5.5 0 0 1 0 1H2.496a.5.5 0 1 1 0-1H4.5zm5.214 0c.158 0 .286.224.286.5s-.128.5-.286.5H6.286C6.128 7 6 6.776 6 6.5s.128-.5.286-.5h3.428zM4.5 9a.5.5 0 0 1 0 1H2.496a.5.5 0 1 1 0-1H4.5zm5.214 0c.158 0 .286.224.286.5s-.128.5-.286.5H6.286C6.128 10 6 9.776 6 9.5s.128-.5.286-.5h3.428zM4.5 12a.5.5 0 1 1 0 1H2.496a.5.5 0 1 1 0-1H4.5zm9-6a.5.5 0 1 1 0 1h-2.004a.5.5 0 0 1 0-1H13.5zm0 3a.5.5 0 1 1 0 1h-2.004a.5.5 0 0 1 0-1H13.5zm0 3a.5.5 0 1 1 0 1h-2.004a.5.5 0 0 1 0-1H13.5zm-3.786 0c.158 0 .286.224.286.5s-.128.5-.286.5H6.286C6.128 13 6 12.776 6 12.5s.128-.5.286-.5h3.428z" />
  </svg>
);

export const icon = EuiIconTableDensityNormal;
